import { useEffect } from "react";
import { OrderProcessingType } from "../../../../../shared/types/OrderProcessingType";
import { NumericFieldWithStepSelector } from "../../../../portfolio-profile/components/chart-settings-button/NumericFieldWithStepSelector";
import { numberFormatters } from "../../../../shared/utils/numberFormatters";

const feeStepOptions = [10, 1, 0.1, 0.01];

type Props = {
    value: number;
    disabled: boolean;
    processingType: OrderProcessingType;
    calculationError?: boolean;
    onValueChange: (value: number) => void;
    onValidityChange: (valid: boolean) => void;
};

export function FeeDetails({
    value,
    disabled,
    processingType,
    calculationError = false,
    onValueChange,
    onValidityChange,
}: Props) {
    useEffect(() => {
        if (!calculationError) {
            onValidityChange(true);
        }
    }, [value, calculationError, onValidityChange]);

    const handleValueChange = (newValue: number): void => {
        const normalizedValue = Math.max(
            0,
            Math.round((newValue + Number.EPSILON) * 100) / 100,
        );

        onValueChange(normalizedValue);
        onValidityChange(true);
    };

    return (
        <NumericFieldWithStepSelector
            id="fee"
            label="Fee"
            value={value}
            onValueChange={handleValueChange}
            formatter={(fee: number) => numberFormatters.format2(
                fee,
                numberFormatters.hideGroupDelimiterFormatOptions,
            )}
            numericFieldStep={0.01}
            disabled={disabled || processingType !== OrderProcessingType.Manual}
            initialSelectedStep={0.01}
            stepOptions={feeStepOptions}
            buttonContent="F"
            tooltipSubject="fee"
            selectorWidth={70}
            error={calculationError}
            helperText={calculationError
                ? "Fee cannot be calculated from the current order values."
                : undefined}
        />
    );
}
